(() => {
  const body = document.body;
  let activeTrigger = null;

  const setLocked = (locked) => {
    body.classList.toggle('vtx-lock-scroll', locked);
  };

  const openLayer = (layer, trigger) => {
    if (!layer) return;
    activeTrigger = trigger || document.activeElement;
    layer.hidden = false;
    setLocked(true);
    window.requestAnimationFrame(() => {
      const focusTarget = layer.querySelector('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])');
      focusTarget?.focus();
    });
  };

  const closeLayer = (layer) => {
    if (!layer) return;
    layer.hidden = true;
    setLocked(Boolean(document.querySelector('.vtx-project-modal:not([hidden]), .vtx-finder-modal:not([hidden]), .vtx-search-modal:not([hidden])')));
    activeTrigger?.focus?.();
  };

  const initHeader = (root) => {
    if (!root || root.dataset.vtxReady) return;
    root.dataset.vtxReady = 'true';

    const disclosures = [...root.querySelectorAll('.vtx-nav-disclosure')];
    disclosures.forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        disclosures.forEach((other) => {
          if (other !== detail) other.removeAttribute('open');
        });
      });
    });

    const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  disclosures.filter((detail) => !detail.hasAttribute('data-vtx-products-menu') && !detail.hasAttribute('data-vtx-projects-menu')).forEach((detail) => {
    detail.addEventListener('mouseenter', () => {
      if (!hoverQuery.matches) return;
      disclosures.forEach((other) => { if (other !== detail) other.open = false; });
      detail.open = true;
    });
    detail.addEventListener('mouseleave', () => {
      if (hoverQuery.matches && !detail.hasAttribute('data-editor-pinned') && !detail.contains(document.activeElement)) detail.open = false;
    });
    detail.querySelector('summary')?.addEventListener('click', (event) => {
      if (hoverQuery.matches && detail.open) event.preventDefault();
    });
  });

  const menuButton = root.querySelector('[data-vtx-mobile-menu-toggle]');
    const mobileMenu = root.querySelector('[data-vtx-mobile-menu]');
    menuButton?.addEventListener('click', () => {
      const shouldOpen = mobileMenu.hidden;
      mobileMenu.hidden = !shouldOpen;
      menuButton.setAttribute('aria-expanded', String(shouldOpen));
    });
    const headerViewport = window.matchMedia('(min-width:990px)');
    headerViewport.addEventListener('change', (event) => {
      if (event.matches && mobileMenu) {
        mobileMenu.hidden = true;
        menuButton?.setAttribute('aria-expanded', 'false');
        mobileMenu.querySelectorAll('details[open]').forEach(detail => { detail.open = false; });
      } else {
        disclosures.forEach(detail => { detail.open = false; });
      }
    });

    const searchModal = root.querySelector('[data-vtx-search-modal]');
    root.querySelector('[data-vtx-search-open]')?.addEventListener('click', (event) => {
      openLayer(searchModal, event.currentTarget);
      window.requestAnimationFrame(() => searchModal.querySelector('input[type="search"]')?.focus());
    });
    root.querySelector('[data-vtx-search-close]')?.addEventListener('click', () => closeLayer(searchModal));
    searchModal?.addEventListener('click', (event) => {
      if (event.target === searchModal) closeLayer(searchModal);
    });
  };

  const initHome = (root) => {
    if (!root || root.dataset.vtxReady) return;
    root.dataset.vtxReady = 'true';

    const advantageImages = [...root.querySelectorAll('[data-vtx-advantage-stage] > img')];
    const advantageControls = [...root.querySelectorAll('[data-vtx-advantage-control]')];
    const showAdvantage = (index) => {
      advantageImages.forEach((image, imageIndex) => {
        image.hidden = imageIndex !== index;
      });
      advantageControls.forEach((control, controlIndex) => {
        control.classList.toggle('is-active', controlIndex === index);
      });
    };
    showAdvantage(0);
    advantageControls.forEach((control, index) => control.addEventListener('click', () => showAdvantage(index)));

    const kitTabs = [...root.querySelectorAll('[data-vtx-kit-tab]')];
    const kitCards = [...root.querySelectorAll('[data-vtx-kit-card]')];
    const showKitGroup = (group) => {
      kitTabs.forEach((tab) => {
        const active = tab.dataset.vtxKitTab === group;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });
      kitCards.forEach((card) => {
        card.hidden = card.dataset.vtxKitCard !== group;
      });
    };
    showKitGroup(kitTabs[0]?.dataset.vtxKitTab || 'exterior');
    kitTabs.forEach((tab) => tab.addEventListener('click', () => showKitGroup(tab.dataset.vtxKitTab)));

    const projectModal = root.querySelector('[data-vtx-project-modal]');
    root.querySelectorAll('[data-vtx-project-open]').forEach((card, cardIndex) => {
      card.addEventListener('click', () => {
        const sourceImage = card.querySelector('img');
        const modalImage = projectModal?.querySelector('[data-vtx-project-modal-image]');
        if (modalImage && sourceImage) {
          modalImage.src = sourceImage.currentSrc || sourceImage.src;
          modalImage.alt = card.dataset.projectTitle || sourceImage.alt;
        }
        const secondaryImage = projectModal?.querySelector('[data-vtx-project-modal-secondary-image]');
        if (secondaryImage) {
          const sourceImageUrl = sourceImage?.currentSrc || sourceImage?.src || '';
          secondaryImage.src =
            card.dataset.projectSecondaryImage ||
            sourceImageUrl.replace(/-1(\.[^/?]+)(\?.*)?$/, '-2$1$2') ||
            sourceImageUrl;
          secondaryImage.alt = `${card.dataset.projectTitle || sourceImage?.alt || 'Project'} detail`;
        }
        const fields = {
          '[data-vtx-project-modal-title]': card.dataset.projectTitle,
          '[data-vtx-project-modal-location]': card.dataset.projectLocation,
          '[data-vtx-project-modal-story]': card.dataset.projectStory,
          '[data-vtx-project-modal-product]': card.dataset.projectProduct,
          '[data-vtx-project-modal-index]': card.dataset.projectIndex || String(cardIndex + 1).padStart(2, '0'),
        };
        Object.entries(fields).forEach(([selector, value]) => {
          const element = projectModal?.querySelector(selector);
          if (element) element.textContent = value || '';
        });
        const productLink = projectModal?.querySelector('[data-vtx-project-modal-product]');
        if (productLink?.matches('a')) productLink.href = card.dataset.projectProductUrl || productLink.getAttribute('href') || '#';
        const requirements = projectModal?.querySelector('[data-vtx-project-modal-requirements]');
        if (requirements) {
          requirements.replaceChildren();
          (card.dataset.projectRequirements || '')
            .split('|')
            .filter(Boolean)
            .forEach((requirement, index) => {
              const item = document.createElement('li');
              const number = document.createElement('b');
              number.textContent = String(index + 1).padStart(2, '0');
              item.append(number, document.createTextNode(requirement));
              requirements.append(item);
            });
        }
        openLayer(projectModal, card);
      });
    });
    root.querySelector('[data-vtx-project-close]')?.addEventListener('click', () => closeLayer(projectModal));
    projectModal?.addEventListener('click', (event) => {
      if (event.target === projectModal) closeLayer(projectModal);
    });

    const finderSource = root.querySelector('[data-vtx-finder-direct]');
  const finderDocumentPromise = finderSource
    ? fetch(finderSource.href.split('#')[0], { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error('Finder request failed');
          return response.text();
        })
        .then((html) => new DOMParser().parseFromString(html, 'text/html'))
    : Promise.reject(new Error('Finder source missing'));

  root.querySelectorAll('[data-vtx-finder-direct]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const picker = link.closest('[data-vtx-hero-project-picker]');
      const hero = picker?.closest('.vtx-hero');
      const content = picker?.closest('.vtx-hero__content');
      if (!picker || !hero || !content) return;

      const selectedLabel = link.textContent.trim();
      const hash = new URL(link.href, window.location.href).hash.slice(1);
      const summary = picker.querySelector('summary');
      if (summary) (summary.querySelector('span') || summary).textContent = selectedLabel;
      picker.open = true;

      let stage = content.querySelector('[data-vtx-hero-finder-stage]');
      if (!stage) {
        stage = document.createElement('div');
        stage.className = 'vtx-hero-finder-stage';
        stage.setAttribute('data-vtx-hero-finder-stage', '');
        picker.insertAdjacentElement('beforebegin', stage);
        stage.appendChild(picker);
      }

      let results = stage.querySelector('[data-vtx-hero-finder-results]');
      if (!results) {
        results = document.createElement('div');
        results.className = 'vtx-hero-finder-results';
        results.setAttribute('data-vtx-hero-finder-results', '');
        stage.appendChild(results);
      }

      results.hidden = false;
      results.dataset.requestKey = hash;
      results.innerHTML = '<div class="vtx-hero-finder-loading">Loading recommendations...</div>';
      hero.classList.add('is-finder-result');
      content.classList.add('is-finder-result');

      finderDocumentPromise
        .then((doc) => {
          if (results.dataset.requestKey !== hash) return;
          const panel = doc.querySelector('.vf__panel[data-hash="' + hash + '"]');
          if (!panel) throw new Error('Finder project not found');
          const clone = panel.cloneNode(true);
          clone.hidden = false;
          clone.removeAttribute('id');
          clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
          clone.querySelectorAll('a[href]').forEach((anchor) => {
            if (window.Shopify?.designMode) {
              anchor.target = '_blank';
              anchor.rel = 'noopener noreferrer';
            } else if (anchor.target === '_parent') {
              anchor.removeAttribute('target');
            }
          });
          results.replaceChildren(clone);
        })
        .catch(() => {
          if (results.dataset.requestKey !== hash) return;
          results.innerHTML = '<div class="vtx-hero-finder-loading">Recommendations are temporarily unavailable. Please try another project.</div>';
        });
    }, { capture: true });
  });

  const finderModal = root.querySelector('[data-vtx-finder-modal]');
    root.querySelectorAll('[data-vtx-open-finder]').forEach((button) => {
      button.addEventListener('click', () => window.location.assign('/pages/fastener-finder'));
    });
    root.querySelector('[data-vtx-finder-close]')?.addEventListener('click', () => closeLayer(finderModal));
    finderModal?.addEventListener('click', (event) => {
            if (event.target === finderModal || event.target.closest?.('.vf__learn, .vf__media')) closeLayer(finderModal);
    });

    window.addEventListener('message', (event) => {
    if (event.origin !== window.location.origin || event.data?.type !== 'vtx:finder:navigate') return;
    const destination = new URL(event.data.href, window.location.origin);
    if (destination.origin !== window.location.origin) return;
    closeLayer(finderModal);
    window.location.assign(`${destination.pathname}${destination.search}${destination.hash}`);
  });

  const projectButtons = [...root.querySelectorAll('[data-vtx-finder-project]')];
    const recommendations = [...root.querySelectorAll('[data-vtx-recommendation]')];
    let selectedProject = projectButtons[0]?.dataset.vtxFinderProject || 'Decking & Subfloor';
    projectButtons.forEach((button) => {
      button.addEventListener('click', () => {
        selectedProject = button.dataset.vtxFinderProject;
        projectButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        const heading = root.querySelector('[data-vtx-finder-heading]');
        const projectLabel = root.querySelector('[data-vtx-finder-project-label]');
        const kicker = root.querySelector('[data-vtx-finder-kicker]');
        const copy = root.querySelector('[data-vtx-finder-copy]');
        if (heading) heading.textContent = selectedProject;
        if (projectLabel) projectLabel.textContent = selectedProject;
        if (kicker) kicker.textContent = 'Project Recommendation';
        if (copy) copy.textContent = 'Tell us the scale of the job. Your recommended products and quantities will appear below.';
        const calculator = root.querySelector('[data-vtx-finder-calculator]');
        if (calculator) calculator.hidden = false;
      });
    });

    root.querySelector('[data-vtx-finder-calculate]')?.addEventListener('click', () => {
      const area = Math.max(1, Number(root.querySelector('[data-vtx-finder-area]')?.value || 1));
      const multiplier = /cabinet|furniture|trim|window/i.test(selectedProject)
        ? 3
        : /framing|post frame|roof/i.test(selectedProject)
          ? 5
          : /concrete|masonry/i.test(selectedProject)
            ? 4
            : 2.5;
      const estimate = Math.ceil((area * multiplier) / 50) * 50;
      const estimateLabel = root.querySelector('[data-vtx-finder-estimate]');
      if (estimateLabel) estimateLabel.textContent = estimate.toLocaleString();
      const results = root.querySelector('[data-vtx-finder-results]');
      if (results) results.hidden = false;
    });
  };

  const initProduct = (root) => {
    if (!root || root.dataset.vtxReady) return;
    root.dataset.vtxReady = 'true';

    const mainImage = root.querySelector('[data-vtx-product-main-image], #VtxProductMainImage');
    const thumbs = [...root.querySelectorAll('[data-vtx-product-thumb]')];
    const mainPlayer = root.querySelector('[data-vtx-product-player]');
    const mainFrame = mainPlayer?.closest('.vx-pdp__main');
    let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    const stopVideo = () => {
      mainPlayer?.querySelectorAll('video').forEach((video) => video.pause());
      mainPlayer?.replaceChildren();
      if (mainPlayer) mainPlayer.hidden = true;
      mainFrame?.classList.remove('is-video');
    };
    const markThumbs = (index) => thumbs.forEach((item, itemIndex) => {
      item.classList.toggle('is-active', itemIndex === index);
      item.setAttribute('aria-pressed', String(itemIndex === index));
    });
    const showImage = (src, alt) => {
      stopVideo();
      if (!mainImage || !src) return;
      mainImage.src = src;
      mainImage.srcset = '';
      mainImage.alt = alt || '';
    };
    const showMedia = (index) => {
      if (!thumbs.length || !mainImage) return;
      activeIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[activeIndex];
      const template = root.querySelector(`template[data-vtx-media-id="${thumb.dataset.mediaId}"]`);
      if (mainPlayer && template) {
        stopVideo();
        mainPlayer.append(template.content.cloneNode(true));
        mainPlayer.hidden = false;
        mainFrame?.classList.add('is-video');
      } else {
        showImage(thumb.dataset.imageSrc, thumb.dataset.imageAlt);
      }
      markThumbs(activeIndex);
    };
    markThumbs(activeIndex);
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showMedia(index)));
    root.querySelector('[data-vtx-gallery-prev]')?.addEventListener('click', () => showMedia(activeIndex - 1));
    root.querySelector('[data-vtx-gallery-next]')?.addEventListener('click', () => showMedia(activeIndex + 1));
    root.querySelectorAll('[data-vtx-product-detail-image]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!mainImage) return;
        showImage(button.dataset.vtxProductDetailImage, button.dataset.imageAlt);
        markThumbs(-1);
      });
    });

    const tabButtons = [...root.querySelectorAll('[data-vtx-product-tab]')];
    const panels = [...root.querySelectorAll('[data-vtx-product-panel]')];
    const showPanel = (key) => {
      tabButtons.forEach((button) => {
        const active = button.dataset.vtxProductTab === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.vtxProductPanel !== key;
      });
    };
    showPanel(tabButtons[0]?.dataset.vtxProductTab || 'applications');
    tabButtons.forEach((button) => button.addEventListener('click', () => showPanel(button.dataset.vtxProductTab)));

    const variantSelect = root.querySelector('[data-vtx-variant-select]');
    const variantInput = root.querySelector('[data-vtx-variant-id]');
    const price = root.querySelector('[data-vtx-product-price]');
    const addButton = root.querySelector('[data-vtx-add-button]');
    const addButtonLabel = addButton?.querySelector('span');
    const quoteButton = root.querySelector('[data-vtx-quote-button]');
    const optionGroups = [...root.querySelectorAll('[data-vtx-option-group]')];
    let variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-vtx-product-variants]')?.textContent || '[]');
    } catch (_error) {
      variants = [];
    }

    const updateVariantState = (switchGallery = true) => {
      if (!variantSelect) return;
      const option = variantSelect.selectedOptions[0];
      if (variantInput) variantInput.value = option.value;
      const coastal = root.hasAttribute('data-coastal-product');
      const showCartEntry = root.hasAttribute('data-cart-entry');
      if (price) price.textContent = Number(option.dataset.priceCents) > 0 || coastal ? option.dataset.price : root.dataset.quoteLabel;
      if (addButton) {
        const available = option.dataset.available === 'true';
        const priceCents = Number(option.dataset.priceCents || 0);
        const canBuy = available && (priceCents > 0 || coastal);
        addButton.hidden = showCartEntry || coastal ? false : !canBuy;
        const stock = root.querySelector('[data-coastal-stock]');
        if (stock) stock.hidden = available;
        addButton.disabled = !canBuy;
        if (addButtonLabel) addButtonLabel.textContent = 'Add to cart';
        if (quoteButton) quoteButton.hidden = false;
      }
      if (quoteButton) {
        const url = new URL(quoteButton.href, location.origin);
        url.searchParams.set('variant', option.value);
        quoteButton.href = url.href;
      }

      const variant = variants.find((item) => String(item.id) === String(option.value));
      if (variant?.options) {
        optionGroups.forEach((group, index) => {
          group.querySelectorAll('[data-vtx-option-value]').forEach((button) => {
            button.classList.toggle('is-active', button.dataset.vtxOptionValue === variant.options[index]);
          });
          const current = group.querySelector('[data-vtx-option-current]');
          if (current) current.textContent = variant.options[index] || '';
        });
      }
      if (switchGallery && variant?.featured_image?.src && mainImage) {
        const mediaIndex = thumbs.findIndex((thumb) => thumb.dataset.mediaId === String(variant.featured_media?.id));
        if (mediaIndex >= 0) showMedia(mediaIndex);
        else {
          showImage(variant.featured_image.src, variant.featured_image.alt);
          markThumbs(-1);
        }
      }
      if (variant?.id && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };

    const selectMatchingVariant = () => {
      if (!variantSelect || !variants.length) return;
      const selectedOptions = optionGroups.map((group) => group.querySelector('[data-vtx-option-value].is-active')?.dataset.vtxOptionValue);
      const variant = variants.find((item) => item.options?.every((value, index) => value === selectedOptions[index]));
      if (!variant) {
        if (addButton) {
          addButton.hidden = true;
          addButton.disabled = true;
        }
        if (addButtonLabel) addButtonLabel.textContent = 'Unavailable';
        if (quoteButton) quoteButton.hidden = false;
        return;
      }
      variantSelect.value = String(variant.id);
      updateVariantState();
    };

    optionGroups.forEach((group) => {
      group.querySelectorAll('[data-vtx-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          group.querySelectorAll('[data-vtx-option-value]').forEach((item) => item.classList.toggle('is-active', item === button));
          const current = group.querySelector('[data-vtx-option-current]');
          if (current) current.textContent = button.dataset.vtxOptionValue;
          selectMatchingVariant();
        });
      });
    });

    variantSelect?.addEventListener('change', updateVariantState);
    updateVariantState(new URL(window.location.href).searchParams.has('variant'));
  };

  const initRfq = (root) => {
    if (!root || root.dataset.vtxReady) return;
    root.dataset.vtxReady = 'true';
    const steps = [...root.querySelectorAll('[data-vtx-rfq-step]')];
    const indicators = [...root.querySelectorAll('[data-vtx-rfq-indicator]')];
    let index = 0;
    const showStep = (shouldScroll = false) => {
      steps.forEach((step, stepIndex) => {
        step.hidden = stepIndex !== index;
      });
      indicators.forEach((indicator, indicatorIndex) => {
        indicator.classList.toggle('is-active', indicatorIndex <= index);
      });
      if (shouldScroll) root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    root.querySelectorAll('[data-vtx-rfq-next]').forEach((button) => {
      button.addEventListener('click', () => {
        const current = steps[index];
        const required = [...current.querySelectorAll('[required]')];
        if (required.some((input) => !input.checkValidity())) {
          required.find((input) => !input.checkValidity())?.reportValidity();
          return;
        }
        index = Math.min(steps.length - 1, index + 1);
        showStep(true);
      });
    });
    root.querySelectorAll('[data-vtx-rfq-back]').forEach((button) => {
      button.addEventListener('click', () => {
        index = Math.max(0, index - 1);
        showStep(true);
      });
    });
    showStep();
  };

  const initFinderPage = (root) => {
    if (!root || root.dataset.vtxLegacyReady) return;
    window.addEventListener('message', (event) => {
    if (event.origin !== window.location.origin || event.data?.type !== 'vtx:finder:navigate') return;
    const destination = new URL(event.data.href, window.location.origin);
    if (destination.origin !== window.location.origin) return;
    closeLayer(finderModal);
    window.location.assign(`${destination.pathname}${destination.search}${destination.hash}`);
  });

  const projectButtons = [...root.querySelectorAll('[data-vtx-finder-project]')];
    if (!projectButtons.length) return;
    root.dataset.vtxLegacyReady = 'true';
    const recommendations = [...root.querySelectorAll('[data-vtx-recommendation]')];
    let selectedProject = projectButtons[0]?.dataset.vtxFinderProject || 'Decking & Subfloor';
    projectButtons.forEach((button) => {
      button.addEventListener('click', () => {
        selectedProject = button.dataset.vtxFinderProject;
        projectButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        const heading = root.querySelector('[data-vtx-finder-heading]');
        const projectLabel = root.querySelector('[data-vtx-finder-project-label]');
        if (heading) heading.textContent = selectedProject;
        if (projectLabel) projectLabel.textContent = selectedProject;
      });
    });
    root.querySelector('[data-vtx-finder-calculate]')?.addEventListener('click', () => {
      const area = Math.max(1, Number(root.querySelector('[data-vtx-finder-area]')?.value || 1));
      const multiplier = /cabinet|furniture|trim|window/i.test(selectedProject)
        ? 3
        : /framing|post frame|roof/i.test(selectedProject)
          ? 5
          : /concrete|masonry/i.test(selectedProject)
            ? 4
            : 2.5;
      const estimate = Math.ceil((area * multiplier) / 50) * 50;
      const estimateLabel = root.querySelector('[data-vtx-finder-estimate]');
      if (estimateLabel) estimateLabel.textContent = estimate.toLocaleString();
      const selectedLabel = root.querySelector('[data-vtx-finder-selected-project]');
      if (selectedLabel) selectedLabel.textContent = selectedProject;
      const projectName = selectedProject.toLowerCase();
      const matchedRecommendations = recommendations.filter((recommendation) => {
        const keywords = (recommendation.dataset.projectKeywords || '')
          .split(',')
          .map((keyword) => keyword.trim())
          .filter(Boolean);
        return keywords.length === 0 || keywords.some((keyword) => projectName.includes(keyword) || keyword.includes(projectName));
      });
      recommendations.forEach((recommendation) => {
        recommendation.hidden = matchedRecommendations.length > 0 && !matchedRecommendations.includes(recommendation);
      });
      const results = root.querySelector('[data-vtx-finder-results]');
      if (results) results.hidden = false;
      results?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  };


  const initGlobalFinder = (root) => {
    if (!root || root.dataset.vtxReady) return;
    root.dataset.vtxReady = 'true';
    const frame = root.querySelector('[data-vtx-global-finder-frame]');
    const closeButtons = [...root.querySelectorAll('[data-vtx-global-finder-close]')];
    let returnFocus = null;

    const close = () => {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('vtx-finder-open');
      returnFocus?.focus?.();
    };

    const open = (trigger) => {
      returnFocus = trigger;
      const rawTarget = trigger?.getAttribute?.('href') || frame?.dataset.src || '/pages/fastener-finder';
      const target = new URL(rawTarget, window.location.origin);
      target.searchParams.set('drawer', '1');
      if (frame && frame.dataset.vtxLoaded !== target.href) {
      frame.dataset.vtxLoaded = target.href;
      fetch(target.href, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error(`Finder request failed: ${response.status}`);
          return response.text();
        })
        .then((html) => {
          const base = `<base href="${window.location.origin}/">`;
          const calculatorClass = target.searchParams.get('calculator') === '1' ? ',"vtx-calculator-embedded"' : '';
          const embedded = `<script>document.documentElement.classList.add("vtx-finder-embedded"${calculatorClass})<\/script>`;
          frame.srcdoc = html.replace(/<head([^>]*)>/i, `<head$1>${base}${embedded}`);
        })
        .catch(() => window.location.assign(target.href));
    } else if (target.searchParams.get('calculator') === '1') {
      frame.contentWindow?.postMessage({type: 'vtx:finder:open-calculator'}, window.location.origin);
    }
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('vtx-finder-open');
      root.querySelector('[data-vtx-global-finder-close]')?.focus();
    };

    window.addEventListener('message', (event) => {
      if (event.source !== frame?.contentWindow || event.origin !== window.location.origin) return;
      if (event.data?.type === 'vtx:finder:close') { close(); return; }
      if (event.data?.type !== 'vtx:finder:navigate') return;
      const destination = new URL(event.data.href, window.location.origin);
      if (destination.origin !== window.location.origin) return;
      close();
      window.location.assign(`${destination.pathname}${destination.search}${destination.hash}`);
    });

    closeButtons.forEach((button) => button.addEventListener('click', close));
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-vtx-open-finder], [data-vtx-global-finder-trigger], a[href*="/pages/fastener-finder"]:not([data-vtx-finder-direct])');
      if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      open(trigger);
    }, true);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !root.hidden) close();
    });

    const pageUrl = new URL(window.location.href);
    if (pageUrl.searchParams.get('openFinder') === '1' || window.location.hash === '#fastener-finder') open(null);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-vtx-header-root]').forEach(initHeader);
    scope.querySelectorAll('[data-vtx-global-finder]').forEach(initGlobalFinder);
    scope.querySelectorAll('[data-vtx-home]').forEach(initHome);
    scope.querySelectorAll('[data-vtx-product]').forEach(initProduct);
    scope.querySelectorAll('[data-vtx-rfq]').forEach(initRfq);
    scope.querySelectorAll('[data-vtx-finder-page]').forEach(initFinderPage);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.vtx-project-modal:not([hidden]), .vtx-finder-modal:not([hidden]), .vtx-search-modal:not([hidden])').forEach(closeLayer);
  });
})();


